var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.215,
    height: 35.216,
    viewBox: "0 0 35.215 35.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icons8-forward-5",
    x: 0,
    y: 0,
    width: 35.215,
    height: 35.216,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(-107.5 -696.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-forward-5-2",
    "data-name": "icons8-forward-5",
    d: "M13.147,9.924a.921.921,0,0,0-.917.812L11.8,14.347a.923.923,0,0,0,.707,1.006l.6.143a.925.925,0,0,0,.75-.149,1.613,1.613,0,0,1,.968-.271q1.463,0,1.464,1.636,0,1.772-1.2,1.772a1.143,1.143,0,0,1-.853-.33,1.163,1.163,0,0,1-.233-.346.922.922,0,0,0-.842-.545h-.507a.921.921,0,0,0-.8,1.385c.035.062.075.12.115.179A3.241,3.241,0,0,0,13.3,19.918a4.2,4.2,0,0,0,1.81.4,3.9,3.9,0,0,0,1.879-.43,3.026,3.026,0,0,0,1.237-1.229,3.623,3.623,0,0,0,.44-1.784,3.636,3.636,0,0,0-.822-2.537,3.006,3.006,0,0,0-2.348-.9,3.02,3.02,0,0,0-.806.113,2.791,2.791,0,0,0-.663.261l.23-2.038H17.4a.922.922,0,0,0,0-1.843Z",
    transform: "translate(112.909 699.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 107.5, 696.28)",
    filter: "url(#icons8-forward-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-forward-5-3",
    "data-name": "icons8-forward-5",
    d: "M15.108,2A13.108,13.108,0,1,1,2,15.108a1.311,1.311,0,1,1,2.622,0A10.5,10.5,0,1,0,9.772,6.086l1.18,1.18a.754.754,0,0,1-.533,1.288H5.374A.753.753,0,0,1,4.622,7.8V2.755a.754.754,0,0,1,1.288-.533L7.875,4.189A13.046,13.046,0,0,1,15.108,2Z",
    transform: "translate(2.5 2.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-forward-10",
    d: "M17.789,17.271c-.25,1.5-1.29,1.645-2.789,1.707v.937h2.56v7.056h1.187l-.021-9.7Z",
    transform: "translate(103.957 692.084)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward);
export default __webpack_public_path__ + "static/media/backward.6d39003196de1a451668fa4bb63eb2ec.svg";
export { ForwardRef as ReactComponent };